import {connect} from 'react-redux';
import classNames from 'classnames';
import {DragDropContext, Droppable} from 'react-beautiful-dnd';

import {moveLocation} from 'topmeteo/loc/actionCreators';

import LocationManagerList from './LocationManagerList';
import LocationManagerFavorite from './LocationMangerFavorite';

const LocationManagerFavorites = ({locations, onMove, editing, onSetEditable, ...props}) => {
    const handleDrop = ({source, destination}) => {
        if (!destination) return;

        const location = locations[source.index];
        const locationAtDestination = locations[destination.index];

        onMove(location, locationAtDestination);
    };

    return (
        <DragDropContext onDragEnd={handleDrop}>
            <Droppable droppableId="location-manager-droppable">
                {({innerRef, droppableProps, placeholder}, {isDraggingOver}) => {
                    const locationManagerListProps = {
                        className: classNames({'is-dragging-over': isDraggingOver}),
                        ref: innerRef,
                        ...droppableProps,
                        ...props,
                    };

                    return (
                        <LocationManagerList {...locationManagerListProps}>
                            {locations.map((location, index) => (
                                <LocationManagerFavorite
                                    key={location.id}
                                    index={index}
                                    location={location}
                                    editing={location === editing}
                                    onSetEditable={() => onSetEditable(location)}
                                />
                            ))}
                            {placeholder}
                        </LocationManagerList>
                    );
                }}
            </Droppable>
        </DragDropContext>
    );
};

const mapStateToProps = ({locations}) => ({
    locations: locations.favorites.map(id => locations[id]),
});

const mapDispatchToProps = dispatch => ({
    onMove: (id, target) => dispatch(moveLocation(id, target)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationManagerFavorites);
